module UspsValidatedAddress {
  class verifyAddressRequest {
    Street: string;
    Street2: string;
    Zip5: string;
  }

  class verifyAddressResponse {
    Street: string;
    Street2: string;
    City: string;
    State: string;
    Zip5: string;
    Zip4: string;

    IsValid: boolean;
  }

  let userAddress1: JQuery<HTMLElement>;
  let userAddress2: JQuery<HTMLElement>;
  let userZip: JQuery<HTMLElement>;

  let uspsAddress1: JQuery<HTMLElement>;
  let uspsAddress2: JQuery<HTMLElement>;
  let uspsCity: JQuery<HTMLElement>;
  let uspsState: JQuery<HTMLElement>;
  let uspsZip5: JQuery<HTMLElement>;
  let uspsZip4: JQuery<HTMLElement>;

  export function construct() {
    userAddress1 = $("#UserAddress1");
    userAddress2 = $("#UserAddress2");
    userZip = $("#UserZip");

    uspsAddress1 = $("#Address");
    uspsAddress2 = $("#Address2");
    uspsCity = $("#City");
    uspsState = $("#State");
    uspsZip5 = $("#Zip5");
    uspsZip4 = $("#Zip4");

    if (userAddress1.length > 0) {
      const addressElements = $("[data-validate=Usps]");
      addressElements.change(addressElementChanged);
      addressElements.keypress(addressElementKeyDowned);
    }
  }

  function addressElementKeyDowned(event: JQuery.Event<HTMLElement, null>) {
    if (event.which == 13) {
      addressElementChanged();
      event.preventDefault();
      $(this).blur();
    }
  }

  function addressElementChanged() {
    clearUspsAddress();

    const address1 = userAddress1.val() as string;
    const address2 = userAddress2.val() as string;
    const zip = userZip.val() as string;

    if (address1 == "" || zip.length != 5) {
      return;
    }

    validateUspsAddress(address1, address2, zip, (verifiedAddress: verifyAddressResponse) => {
      if (verifiedAddress.IsValid) {
        uspsAddress1.val(verifiedAddress.Street);
        uspsAddress2.val(verifiedAddress.Street2);
        uspsCity.val(verifiedAddress.City);
        uspsState.val(verifiedAddress.State);
        uspsZip5.val(verifiedAddress.Zip5);
        uspsZip4.val(verifiedAddress.Zip4);
      }
      else {
        Notifications.Warning("Address was not found in USPS database.");
      }
    });
  }

  function clearUspsAddress() {
    uspsAddress1.val("");
    uspsAddress2.val("");
    uspsCity.val("");
    uspsState.val("0");
    uspsZip5.val("");
    uspsZip4.val("");
  }

  export function validateUspsAddress(address1: string, address2: string, zip: string, callback: (verifiedAddress: verifyAddressResponse) => any) {
    const requestData = {
      Street: address1,
      Street2: address2,
      Zip5: zip
    } as verifyAddressRequest;
    $.ajax(
      "/Api/AddressValidation/VerifyAndCleanseAddress",
      {
        data: JSON.stringify(requestData),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        type: "POST",
        timeout: 5000,
        success: callback,
        error: () => Notifications.Warning("Not validate address with USPS.  Enter address manually.")
      }
    );
  }
}